// ** Dropdowns Imports
import UserDropdown from "./UserDropdown";
import NotificationDropdown from "./NotificationDropdown";
import { PlusSquare } from "react-feather";
import { Plus } from "react-feather";
import { Button } from "reactstrap";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { notNullString } from "@src/utility/StringUtil";
import ModalSitesCreate from "@src/views/sites/components/ModalCreate";
import { useSelector } from "react-redux";
import { RootState } from "@src/redux";
import { AccountFeatures } from "@src/redux/reducers/accountFeatures";

const NavbarUser = () => {
  const [showModalCreateSite, setShowModalCreateSite] = useState(false);
  const { canCreateSite } = useSelector<RootState, AccountFeatures>(
    (state) => state.accountFeatures
  );
  const { t } = useTranslation();
  return (
    <>
    {canCreateSite && (
      <ul
        className="btn-add-site"
        style={{
          height: "100%",
          width: "40px",
          padding: "0px",
          margin: "0px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%"
        }}
      >
        <button
           /* Adicionamos apenas a classe do foco aqui */
          style={{
            margin: "0px",
            padding: "0px",
            width: "20px",
            height: "20px",
            backgroundColor: "transparent",
            color: "#000000",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            borderRadius: "12px"
          }}
          aria-label={notNullString(t("menu.addSite"))}
          title={notNullString(t("menu.addSite"))}
          onClick={() => setShowModalCreateSite(!showModalCreateSite)}
        >
          <Plus size={20} />
        </button>
        {/* <NotificationDropdown /> */}
        {/* <UserDropdown  /> */}
      </ul>
    )}
    
    <ModalSitesCreate
        index={0} opened={showModalCreateSite} setOpened={setShowModalCreateSite} typeVision={"CREATE"} 
    />
    </>
  );
};
export default NavbarUser;